import React from 'react';
import PropTypes from 'prop-types';

export const EmptyStoreMessage = ({ isGCC }) => {
  if (isGCC) { return <div className="store__empty__mw-whitespace" />; }
  return <div className="store__empty" />;
};

EmptyStoreMessage.propTypes = {
  isGCC: PropTypes.bool
};

EmptyStoreMessage.defaultProps = {
  isGCC: false
};
